/**
 * Checks if a value is within a specified range.
 * If min is null or undefined, there is no lower bound.
 * If max is null or undefined, there is no upper bound.
 * @param value
 * @param min
 * @param max
 * @param param3
 */
export function isWithinRange(
  value: number,
  min: number | null | undefined,
  max: number | null | undefined,
  { minInclusive = true, maxInclusive = false }: { minInclusive?: boolean; maxInclusive?: boolean } = {}
): boolean {
  const minCheck = min == null ? true : minInclusive ? value >= min : value > min;
  const maxCheck = max == null ? true : maxInclusive ? value <= max : value < max;
  return minCheck && maxCheck;
}
